import { getUserIdent, trackEvent } from "~/api/hkzxcs";
import { getChannel } from "~/utils/getChannel";

/**
 * 埋点上报
 * @param {*} channel 必填 渠道
 * @param {*} project_id 必填 付费点
 * @param {*} page_version 非必填 页面版本
 * @param {*} event_name 必填 事件名称
 * @param {*} extend 非必填 扩展参数
 */

let userIdPromise = null; // 用于锁定的 Promise，避免同时多次调用产生重复请求

export async function customTrackEvent(event_name, extend = {}) {
  // trycatch一下 避免影响正常流程
  try {
    let storedUserId = localStorage.getItem("USER_IDENT");

    // 如果 storedUserId 不存在，且 userIdPromise 为空，发起请求
    if (!storedUserId && !userIdPromise) {
      userIdPromise = getUserIdent();
    }

    let channel = getChannel();

    // 如果存在 userIdPromise，等待其完成
    if (userIdPromise) {
      const res = await userIdPromise;
      userIdPromise = null; // 请求完成后，释放锁定
      if (res.code === 200) {
        storedUserId = res.data.user_ident;
        localStorage.setItem("USER_IDENT", res.data.user_ident);
      }
    }

    if (!storedUserId || !channel || !event_name) return;

    let params = {
      event: event_name, //事件名称
      channel,
      product_id: "xzgw", //付费点
      page_version: 0, //页面版本 (如果没有值，默认0)
      request_uri: location.href, //页面链接
      ident_uid: storedUserId, //用户身份标识
    };
    // 补充扩展字段，order_id 字段单独传参，其他字段统一放到 extend 字段中
    if (extend && Object.keys(extend).length > 0) {
      const { order_id, ...otherProps } = extend;

      if (order_id) {
        params.order_id = order_id;

        if (Object.keys(otherProps).length > 0) {
          params.extend = JSON.stringify(otherProps);
        }
      } else {
        params.extend = JSON.stringify(extend);
      }
    }
    // 上报数据
    trackEvent(params);
  } catch (error) {
    console.error("trackEvent 错误", error);
  }
}
